import { Controller } from "@hotwired/stimulus";

// Clipboard: copies the text of the `source` target, and says so by swapping the
// button's icon for a tick until the reader looks away — a copy that reports
// nothing back leaves them pressing it twice.
//
//   <div data-controller="clipboard">
//     <code data-clipboard-target="source">…</code>
//     <button data-action="clipboard#copy">
//       <span data-clipboard-target="idle">…</span>
//       <span data-clipboard-target="done" class="hidden">…</span>
//     </button>
//   </div>
export default class extends Controller {
  static targets = ["source", "idle", "done"];
  static values = { confirmDuration: { type: Number, default: 2000 } };

  disconnect() {
    clearTimeout(this.timeout);
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.sourceTarget.textContent.trim());
    } catch {
      // A denied permission or an unfocused document: select the text instead of
      // claiming a copy that did not happen, so the keyboard can still take it.
      this.select();
      return;
    }

    this.confirm();
  }

  select() {
    const range = document.createRange();
    range.selectNodeContents(this.sourceTarget);

    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  }

  confirm() {
    this.idleTarget.classList.add("hidden");
    this.doneTarget.classList.remove("hidden");

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.doneTarget.classList.add("hidden");
      this.idleTarget.classList.remove("hidden");
    }, this.confirmDurationValue);
  }
}
